<header class="header-inner" (click)="closeProfileMenu()">
  <div class="header-left">
    <button
      class="mobile-menu-toggle"
      (click)="onToggleMobileMenu(); $event.stopPropagation()"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        stroke-width="2.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      >
        <line x1="4" y1="12" x2="20" y2="12" />
        <line x1="4" y1="6" x2="20" y2="6" />
        <line x1="4" y1="18" x2="20" y2="18" />
      </svg>
    </button>
  </div>

  <div class="header-right">
    <!-- <button class="notification-btn">
      <i class="bi bi-bell-fill"></i>
      <span class="notification-badge"></span>
    </button> -->

    <div class="profile-selector-container" *ngIf="userDetail">
      <button class="profile-trigger-btn" (click)="toggleProfileMenu($event)">
        <div class="avatar-badge">
          {{ userDetail.first_name.charAt(0)
          }}{{ userDetail.last_name.charAt(0) }}
        </div>

        <div class="profile-details-text">
          <span class="profile-company">
            {{ userDetail.first_name }} {{ userDetail.last_name }}
          </span>

          <span class="profile-user-email">
            {{ userDetail.phone_email }}
          </span>
        </div>

        <!-- <svg
          class="chevron-down-icon"
          [class.rotated]="showProfileMenu"
          xmlns="http://www.w3.org/2000/svg"
          width="14"
          height="14"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2.5"
          stroke-linecap="round"
          stroke-linejoin="round"
        >
          <polyline points="6 9 12 15 18 9" />
        </svg> -->
      </button>

      <!-- <div
        class="profile-dropdown-menu"
        *ngIf="showProfileMenu"
        (click)="$event.stopPropagation()"
      >
        <div class="menu-header">
          <span class="menu-company-name">
            {{ userDetail.first_name }} {{ userDetail.last_name }}
          </span>

          <span
            class="menu-company-domain"
            [matTooltip]="userDetail.phone_email"
          >
            {{
              userDetail.phone_email.length > 25
                ? (userDetail.phone_email | slice: 0 : 25) + "..."
                : userDetail.phone_email
            }}
          </span>
        </div>
        <div class="menu-divider"></div> -->

        <!-- <a class="menu-item">Profile Settings</a>
        <a class="menu-item">Organization</a>
        <a class="menu-item">API Keys</a> -->
       <!----<div class="menu-divider"></div>
        <a class="menu-item logout-menu-item" (click)="onLogout()"> Logout </a>
      </div> -->
    </div>
  </div>
</header>
